import { Fragment, useContext, useEffect, useState } from "react";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { nameof } from "../../operation/component/common/ObjectUtils";
import { ExportTypes } from "../../operation/component/exports/Types";
import { useAgGridCustomDatasource } from "../../operation/hooks/useAgGridCustomDatasource";
import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import SectionHeader from "../../../util/component/SectionHeader";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { ContextOperation } from "../../operation/context/OperationContext";
import AgGridOperationTable from "../../operation/component/common/AgGridOperationTable";
import RsExportService from "./RsExportService";
import { saveFileFromResponse } from "../../operation/utils";

const RsExportPage = (params: {exportType: string}) => {
  const { t } = useTranslation(["network"]);
  const { tenant, setLoading } = useContext(ContextOperation);
  const [refreshPage, setRefreshPage] = useState<boolean>(false);

  const pageTitle = () : any => {
    /*
    if (params.exportType === 'VEHICLE') {
      return t("export.titleVehicle");
    } else if (params.exportType === 'MASSIVE_VEHICLE_LOCK') {
      return t("export.titleMassiveVehicleLock");
    } else if (params.exportType === 'DAMAGE_FORM') {
      return t("export.titleDamageForm");
    } else if (params.exportType === 'RECEIVE_FROM_LEASYS') {
      return t("export.titleReceiveFromLeasys");
    } else if (params.exportType === 'TRANSFER_REQUEST') {
      return t("export.titleTransferRequest");
    } else if (params.exportType === 'DELIVERY_NOTE') {
      return t("export.titleDeliveryNote");
    }
    */
   if (params.exportType === 'SHOP') {
      return t("export.titleRs");
    } else if (params.exportType === 'MASSIVE_SHOP_LOCK') {
      return t("export.titleMassiveRsLock");
    }
  };

  const exportTypeEndpoint = () : any => {
    /*
    if (params.exportType === 'VEHICLE' || params.exportType === 'MASSIVE_VEHICLE_LOCK') {
      return RsExportService.vehicle.get.asyncExport;
    } else if (params.exportType === 'DAMAGE_FORM' || params.exportType === 'RECEIVE_FROM_LEASYS') {
      return RsExportService.damage.get.asyncExport;
    } else if (params.exportType === 'TRANSFER_REQUEST' || params.exportType === 'DELIVERY_NOTE') {
      return RsExportService.transportation.get.asyncExport;
    }
    */
    if (params.exportType === 'SHOP' || params.exportType === 'MASSIVE_SHOP_LOCK') {
      return RsExportService.network.repairshop.get.asyncExport;
    }
  };

  useEffect(() => {
    setRefreshPage(!refreshPage);
  }, [params]);

  const [datasourceAcriss, totalElementsAcriss] = 
    useAgGridCustomDatasource(
      exportTypeEndpoint(), 
      [{
        type: params.exportType
      }], 
      [refreshPage]);

  const exportColums: ColDef[] = [
    {
      field: nameof<ExportTypes.TableData>("filename"),
      headerName: t("export.filename"),
      flex: 1,
      minWidth: 150,
    },
    {
      field: nameof<ExportTypes.TableData>("createDatetime"),
      headerName: t("export.createDatetime"),
      flex: 1,
      minWidth: 200,
      cellRenderer: (params: ICellRendererParams) =>
        dateFormat(params.data?.createDatetime),
    },
    {
      field: nameof<ExportTypes.TableData>("expirationDatetime"),
      headerName: t("export.expirationDatetime"),
      flex: 1,
      minWidth: 200,
      cellRenderer: (params: ICellRendererParams) =>
        dateFormat(params.data?.expirationDatetime),
    },
    {
      field: nameof<ExportTypes.TableData>("status"),
      headerName: t("export.status"),
      flex: 1,
      minWidth: 100,
      cellRenderer: (params: ICellRendererParams) =>
        statusShow(params.data?.status),
    },
    {
      field: "",
      maxWidth: 100,
      minWidth: 100,
      pinned: "right",
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <Mui.Tooltip title={t("tooltipTitle.download")}>
            <Mui.Button
              variant="text"
              size="icon"
              disabled={params.data?.status === "PROCESSED" ? false : true}
              onClick={() => downloadExcel(params.data?.id)}
            >
              <MuiIcons.Download />
            </Mui.Button>
          </Mui.Tooltip>
        );
      },
    },
  ];

  const statusShow = (status: string) => {
    switch (status) {
      case "PROCESSED":
        return (
          <Mui.Chip
            label={t("export.processed")}
            variant="filled"
            color="success"
          />
        );
      case "PENDING":
        return (
          <Mui.Chip
            label={t("export.pending")}
            variant="filled"
            color="warning"
          />
        );
      case "ERROR":
        return (
          <Mui.Chip
            label={t("export.error")}
            variant="filled"
            color="error"
          />
        );
      default:
        return <Mui.Chip label={status} variant="filled" color="info" />;
    }
  };

  const dateFormat = (date: string) => {
    if (date)
      return <Mui.Stack>{dayjs(date).format("DD/MM/YYYY-HH:mm")}</Mui.Stack>;
  };

  const downloadExcel = (id: number) => {
    if (id) {
      setLoading(true);     
      
      if (params.exportType === 'SHOP' || params.exportType === 'MASSIVE_SHOP_LOCK') {   
        RsExportService.network.repairshop.get.asyncExportById(id).then((response) => {
          saveFileFromResponse(response);
          setLoading(false);
        });
      }
      /*
      if(params.exportType === 'VEHICLE' || params.exportType === 'MASSIVE_VEHICLE_LOCK') {
        RsExportService.vehicle.get.asyncExportById(id).then((response) => {
          saveFileFromResponse(response);
          setLoading(false);
        });
      } else if(params.exportType === 'DAMAGE_FORM' || params.exportType === 'RECEIVE_FROM_LEASYS') {
        RsExportService.damage.get.asyncExportById(id).then((response) => {
          saveFileFromResponse(response);
          setLoading(false);
        });
      } else if(params.exportType === 'TRANSFER_REQUEST' || params.exportType === 'DELIVERY_NOTE') {
        RsExportService.transportation.get.asyncExportById(id).then((response) => {
          saveFileFromResponse(response);
          setLoading(false);
        });
      }
      */

    }
  };

  return (
    <Fragment>
      <SectionHeader title={pageTitle()} />

      <Mui.Box p={3}>
        <Mui.Card>
          <Mui.Box sx={{ justifyContent: "flex-end", display: "flex", mr: 2 }}>
            <Mui.Tooltip title={t("export.refreshTable")}>
              <Mui.Button
                variant="text"
                size="icon"
                color="accent"
                onClick={() => setRefreshPage(!refreshPage)}
              >
                <MuiIcons.Cached sx={{ fontSize: "22px" }} />
              </Mui.Button>
            </Mui.Tooltip>
          </Mui.Box>
        </Mui.Card>
        <AgGridOperationTable
          columnDefs={exportColums}
          serverSideDatasource={datasourceAcriss}
          serverSideInfiniteScroll={true}
          cacheBlockSize={10}
          rowModelType="serverSide"
          totalElements={totalElementsAcriss}
          emptyState={{
            title:t("emptyStateGrid.title"),
            content:t("emptyStateGrid.content")
          }}
        />
      </Mui.Box>
    </Fragment>
  );
};

export default RsExportPage;
